import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import { updateMyOrg } from "./_actions";

class OrgDetailsModal extends React.Component {
    _validate = (values) => {
        const errors = {};

        errors.name = FormUtils.validators.required(values.name);
        errors.name = errors.name || FormUtils.validators.nameRegex(values.name);
        errors.name = errors.name || FormUtils.validators.maxLength(50)(values.name);

        return errors;
    };

    _save = (values) => {
        this.props.updateMyOrg(values);
    };

    render() {
        const { account } = this.props;

        return (
            <Form initialValues={account} validate={this._validate} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Edit my org" skinny>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="name" label="Name" placeholder="This may be the organisation/farm name or your own name." required component={InputPack} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button Button--primary" disabled={submitSucceeded}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withAppContext,
    withActions({ updateMyOrg }),
    withState((state, ownProps) => {
        const {
            viewModel: { account },
        } = ownProps;
        return {
            account,
        };
    })
)(OrgDetailsModal);
